import { OrangeButton, FlexDiv } from 'src/components/portal/default'
import { MdOpenInNew } from 'react-icons/md'
import { tlieSources } from 'src/constants/tlie'

const CyberRiskManagement = () => {
  return (
    <FlexDiv gap="64px" dir="column">
      <a href={tlieSources.cyberRiskManagement} target="_blank" rel="noopener" style={{ textDecoration: 'none' }}>
        <OrangeButton style={{ gap: '12px' }}>Learn More on CyberNET <MdOpenInNew /></OrangeButton>
      </a>
    </FlexDiv>
  )
}

export default CyberRiskManagement